import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import "../css/bootstrap.css"

const Header = ({ siteTitle }) => (


  <header
    style={{
      // background: `rebeccapurple`,
      // background: `#21abb5`,
      background: `rgba(1, 119, 130, 0.9)`,
      marginBottom: `1.45rem`,
      // height: `50px`,
      position: `fixed`,
      width: `100%`,
      top: `0px`,
      zIndex: 5

    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        // padding: `1.45rem 1.0875rem`,
        padding: `0.5rem`,
      }}
    >
      <h2 style={{ margin: 5 }}>
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          {siteTitle}
        </Link>
        <Link style={{ float: `right` }} to="/modals/subscribe" state={{
          modal: true
        }}>
          <p style={{ fontSize: `12px`, float: `right`, backgroundColor: `#ffffff`, padding: `8px`, borderRadius: `2px`, color: `#017681` }}>Subscribe</p>
        </Link>
      </h2>
    </div>
  </header >
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header